module.exports = __webpack_public_path__ + "static/media/EuclidCircularB-Bold.90bcd347.woff2";